<template>
    <div>
        <b-skeleton v-if="isLoading" class="my-skeleton" width="395" height="548"></b-skeleton>
        <div class="my-content" v-if="invoice && !isLoading">
            <div style="text-align: center;">
                <img src="@/assets/images/logo.svg" width="100" alt="">
            </div>
            <div style="text-align: center; font-weight: bold; font-size: 16pt; border-bottom: 1px dashed #000; padding-bottom: 5px; color: black;">
                <p>DALOUNNY CLOSET</p>
            </div>
            <div style="text-align: center; font-weight: bold; font-size: 16pt; padding-top: 15px; padding-bottom: 10px; color: black;">
                <p>RECEIPT</p>
            </div>
            <div style="display: flex; justify-content: space-between; font-size: 10pt; color: black;">
                <p>
                    <strong>RECEIPT NO.: {{invoice.invoiceNumber}}</strong><br>
                    <strong>PAYMENT METHOD: {{invoice.paymentMethod}}</strong>
                </p>
                <p><strong>DATE: {{ invoice.created | formatEuDate }}</strong></p>
            </div>
            <div style="margin-top: 10px; font-size: 10pt; border-bottom: 1px dashed #000; padding-bottom: 10px; font-weight: bold; color: black;">
                <div style="display: flex; padding-top: 5px;;">
                    <div style="flex: 2.3;">ITEM</div>
                    <div style="flex: 0.5; text-align: center;">QTY</div>
                    <div style="flex: 1.1; text-align: right">PRICE</div>
                </div>
                <div style="display: flex; padding-top: 5px;"
                     v-for="(item, index) in items" :key="index">
                    <div style="flex: 2.3;">{{item.name}}</div>
                    <div style="flex: 0.5; text-align: center;">{{item.qty}}</div>
                    <div style="flex: 1.1; text-align: right;">{{item.price | formatMoney }} KIP</div>
                </div>
            </div>
            <div style="text-align: right; margin-top: 8px; font-weight: bold; color: black;">
                <div style="display: flex; font-size: 10pt; justify-content: right;">
                    <div style="flex: 1.8">SUBTOTAL:</div>
                    <div style="flex: 1"><strong>{{ invoice.total - ((invoice.total * 10) / 100) | formatMoney
                        }}</strong> KIP
                    </div>
                </div>
                <div style="display: flex; font-size: 10pt; justify-content: right;">
                    <div style="flex: 1.8">DISCOUNT:</div>
                    <div v-if="invoice.discountType === 'PERCENT'" style="flex: 1"><strong>{{ invoice.discountValue
                        }}%</strong></div>
                    <div v-else-if="invoice.discountType === 'FIX'" style="flex: 1"><strong>{{ invoice.discountValue |
                        formatMoney }}</strong> KIP
                    </div>
                    <div v-else style="flex: 1"><strong>0</strong></div>
                </div>
                <div style="display: flex; font-size: 10pt; justify-content: right;">
                    <div style="flex: 1.8">TAX:</div>
                    <div style="flex: 1"><strong>10%</strong></div>
                </div>
                <div v-if="invoice.paymentMethod === 'CASH'"
                     style="display: flex; font-size: 10pt; justify-content: right;">
                    <div style="flex: 1.8">CASH:</div>
                    <div style="flex: 1"><strong>{{ invoice.cash | formatMoney }}</strong> KIP</div>
                </div>
                <div v-if="invoice.paymentMethod === 'CASH'"
                     style="display: flex; font-size: 10pt; justify-content: right;">
                    <div style="flex: 1.8">CHANGE:</div>
                    <div style="flex: 1"><strong>{{ invoice.cashChange | formatMoney }}</strong> KIP</div>
                </div>
                <div style="display: flex; font-size: 10pt; justify-content: right;">
                    <div style="flex: 1.8">TOTAL:</div>
                    <div style="flex: 1"><strong>{{ invoice.total - discountPrice | formatMoney }}</strong> KIP</div>
                </div>
            </div>
            <div class="receipt-footer">
                <div class="thank-you">
                    <p>Thank you for shopping with us</p>
                    <p>Hope to see you again</p>
                </div>
                <div class="contact">
                    <qrcode-vue value="https://www.facebook.com/dalounnycloset" size="60" level="H"></qrcode-vue>
                    <div>
                        <p>FB: https://www.facebook.com/dalounnycloset</p>
                        <p>TEL: (+856-20)-56012222</p>
                    </div>
                </div>
            </div>
            <div class="btn no-print">
                <b-button type="is-primary"
                          icon-right="printer" @click="print"/>
                <b-button type="is-danger"
                          icon-right="arrow-left" @click="back"/>
            </div>
        </div>
    </div>
</template>

<script>
    import {paymentsCollection} from "../firebase";
    import QrcodeVue from 'qrcode.vue'

    export default {
        name: "Receipt",
        components: {
            QrcodeVue
        },
        data() {
            return {
                isLoading: false,
                invoiceNumber: this.$route.params.invoice,
                invoice: null,
                items: null,
            }
        },

        mounted() {
            this.getInvoice();
        },
        computed: {
            discountPrice() {
                let discount = 0;
                if (this.invoice.discountType === 'PERCENT') {
                    discount = (this.invoice.total * this.invoice.discountValue) / 100;
                }
                if (this.invoice.discountType === 'FIX') {
                    discount = this.invoice.discountValue.toString().replace(/,/g, '');
                }
                return parseInt(discount);
            },
        },
        methods: {
            getInvoice: function () {
                this.isLoading = !this.isLoading;
                paymentsCollection.where('invoiceNumber', '==', this.invoiceNumber).get()
                    .then(res => {
                        res.forEach(docSnapshot => {
                            this.invoice = docSnapshot.data();
                            this.items = this.invoice.items;
                        });
                        this.isLoading = !this.isLoading;
                    }).catch(err => {
                    this.isLoading = !this.isLoading;
                    console.log(err);
                    this.$swal({
                        text: err,
                        icon: "error",
                        showCancelButton: true,
                    }).then((result) => {
                        if (result.value) {
                            this.$router.replace('/invoices');
                        }
                    });
                });
            },
            print() {
                window.print();
            },
            back() {
                this.$router.replace('/invoices');
            }
        },
    }
</script>

<style scoped lang="scss">
    @media print {
        @page {
            /*margin: 0.2cm 1cm 0 1cm;*/
            margin: 0;
            /*size: 105mm 145mm;*/
        }
        .receipt-footer {

        }
        .my-content {
            margin-top: 0 !important;
            padding-left: 20px !important;
            padding-right: 40px !important;
        }
    }

    .my-content {
        width: 105mm;
        min-height: 145mm;
        padding: 20px 40px;
        margin: 0 auto;
        position: relative;
    }

    .receipt-footer {
        text-align: center;
        position: relative;
        margin-top: 40px;

        .thank-you {
            border-top: 1px dashed #000;
            border-bottom: 1px dashed #000;
            font-size: 9pt;
            font-weight: normal;
            text-transform: uppercase;
            margin-bottom: 10px;
            padding: 5px 0;
            color: #000;
        }

        .contact {
            display: flex;
            text-align: left;
            align-items: flex-start;
        }

        .contact > div {
            font-size: 8pt;
            font-weight: normal;
            margin-left: 10px;
            color: #000;
        }
    }

    .btn {
        position: absolute;
        right: -60px;
        top: 0;

        button {
            border-radius: 50px;
            display: block;
            margin: 5px 0;
        }
    }
    .b-skeleton-item {
        margin: 0 auto;
    }
    strong {
        color: #000;
    }
</style>